import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ToastService } from "src/app/services/toast.service";
import { TenantSensorService } from "src/app/services/tenantSensor.service";
import { MatDialog } from "@angular/material/dialog";
import nameOf from "src/app/shared/form/nameOf.helper";
import {
    ConfirmDialogComponent,
    ConfirmDialogData,
} from "src/app/shared/confirmDialog/confirmDialog.component";
import { TenantSensor } from "src/app/models/tenantSensor.model";
import { Router } from "@angular/router";
import { TimeZoneService } from "src/app/services/timeZone.service";
import { AuthService } from "src/app/services";
import { BaseGridComponent } from "src/app/shared/grid/baseGrid.component";
import { CreateTenantSensorDialogComponent } from "src/app/modals/createTenantSensorDialog/createTenantSensorDialog.component";
import { EditTenantSensorDialogComponent } from "src/app/modals/editTenantSensorDialog/editTenantSensorDialog.component";
import { ConfigureSensorDialogComponent } from "src/app/modals/configureSensorDialog/configureSensorDialog.component";
import { CommonService } from "src/app/services/common.service";
import { GridViewService } from "src/app/services/grid-view.service";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageConstants } from "src/app/shared/constants/localStorage.constants";
import { RoutePaths } from "src/app/shared/constants/routePaths.constants";

@Component({
  standalone: false,
    selector: "app-tenant-sensor-list",
    templateUrl: "tenantSensorList.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["tenantSensorList.component.scss"],
})
export class TenantSensorListComponent extends BaseGridComponent<TenantSensor> {
    timeZoneLabel: string;

    constructor(
        protected tenantSensorService: TenantSensorService,
        private router: Router,
        toastService: ToastService,
        authService: AuthService,
        timeZoneService: TimeZoneService,
        dialog: MatDialog,
        commonService: CommonService,
        gridViewService: GridViewService,
        private translateService: TranslateService,
    ) {
        super(toastService, dialog, commonService, gridViewService);
        this.timeZoneLabel = timeZoneService.createTimeZoneLabel(
            authService.getCurrentUser().userTimeZone,
        );
        this.gridService = tenantSensorService;
        this.displayedColumns = [
            "Tenant.Name",
            nameOf<TenantSensor>((x) => x.name),
            nameOf<TenantSensor>((x) => x.id),
            "DeviceVersion.Version",
            nameOf<TenantSensor>((x) => x.status),
            nameOf<TenantSensor>((x) => x.imeI_No),
            nameOf<TenantSensor>((x) => x.latitude),
            nameOf<TenantSensor>((x) => x.longitude),
            nameOf<TenantSensor>((x) => x.installationDate),
            nameOf<TenantSensor>((x) => x.gpsCapability),
            nameOf<TenantSensor>((x) => x.tableNames),
            nameOf<TenantSensor>((x) => x.videoCapability),
            nameOf<TenantSensor>((x) => x.density),
            nameOf<TenantSensor>((x) => x.configurationCapability),
            "action",
        ];
    }

    setSensorId(sensor: TenantSensor) {
        const encSensorId = window.btoa(sensor.id);
        localStorage.setItem(LocalStorageConstants.deviceName, encSensorId);
        this.router.navigate([RoutePaths.sensor]);
    }

    add() {
        const dialogRef = this.dialog.open(CreateTenantSensorDialogComponent, {
            data: {},
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }

    edit(sensor: TenantSensor) {
        const dialogRef = this.dialog.open(EditTenantSensorDialogComponent, {
            data: { id: sensor.id },
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }

    configure(sensor: TenantSensor) {
        const dialogRef = this.dialog.open(ConfigureSensorDialogComponent, {
            data: { id: sensor.id },
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }

    delete(sensor: TenantSensor) {
        const data: ConfirmDialogData = {
            title: this.translateService.instant("Delete Sensor"),
            message: this.translateService.instant(
                "Are you sure you want to delete sensor {{id}}?",
                { id: sensor.id },
            ),
            primaryButtonText: this.translateService.instant("Delete"),
            primaryCallback: () =>
                this.tenantSensorService.deleteTenantSensor(sensor.id),
            successMessage: this.translateService.instant(
                "Sensor deleted successfully!",
            ),
            secondaryButtonText: this.translateService.instant("Cancel"),
            errorMessage: "",
        };
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data,
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }
}
